import { ViewMode } from '@/sections/Workspace/types';
import localStorageEffect from '@/utils/recoil/localStorageEffect';
import { atomFamily } from 'recoil';

import { Filter, SortBy, SortByTraining } from './types';

const viewModeState = atomFamily<ViewMode, string /* teamId + section */>({
  default: ViewMode.List,
  key: 'workspace-view-mode',
  effects: (key) => [localStorageEffect(`n-workspace-view-mode-${key}`)],
});

const filterQueryState = atomFamily<string, string /* teamId + section */>({
  default: '',
  key: 'workspace-filter-query',
  effects: (kay) => [localStorageEffect(`workspace-filter-query-${kay}`)],
});

const filterSortByState = atomFamily<SortBy | SortByTraining, string /* teamId + section */>({
  default: SortBy.PRODUCTION,
  key: 'workspace-filter-sort-by',
  effects: (key) => [localStorageEffect(`workspace-filter-sort-by-${key}`)],
});

const filterStatusState = atomFamily<Filter, string /* teamId + section */>({
  default: Filter.All,
  key: 'workspace-filter-status',
  effects: (key) => [localStorageEffect(`workspace-filter-status-${key}`)],
});

export { viewModeState, filterQueryState, filterSortByState, filterStatusState };
